import withCurrentUser from 'components/withCurrentUser'

const FeatureFlag = ({
  active = () => null,
  inactive = () => null,
  name,
  currentUser
}) => (currentUser && currentUser.flags[name] ? active() : inactive())

export default withCurrentUser(FeatureFlag)



// WEBPACK FOOTER //
// ./src/components/FeatureFlag.js